import dayjs from 'dayjs'

/**
 * Formats a date string using dayjs
 * @param {string} date - The date string to format
 * @param {string} [pattern='MMM DD, YYYY'] - The date format pattern to use
 * @returns {string} The formatted date string, or empty string if date is falsy
 */
export function formatDate(date: string, pattern = 'MMM DD, YYYY'): string {
  return date ? dayjs(date).format(pattern) : ''
}

/**
 * Combines first and last name into a display name
 * @param {string} firstName - The person's first name
 * @param {string} lastName - The person's last name
 * @returns {string} The combined display name, filtering out any falsy values
 */
export function displayName(firstName: string, lastName: string): string {
  return [firstName, lastName].filter(Boolean).join(' ')
}

/**
 * Truncates text to a specified length and adds ellipsis
 * @param {string} text - The text to truncate
 * @param {number} length - The maximum length before truncation
 * @returns {string} The truncated text with ellipsis if truncated, or original text if within length
 */
export function truncate(text: string, length: number): string {
  return text.length > length ? text.slice(0, length) + '...' : text
}
